var argon = require('./argon.js');

/* This module needs the following global functions to be defined (in
 * window perhaps).
 *
 * _readFile(cbFn): Function to read a JSON theme file and invoke the
 * specified callback function with the contents of the file as a
 * string.
 *
 * _saveFile(fileName, dataURI): Function to save the file using the
 * suggested name and the data: URI
 *
 * _formatFunc(array): (optional) Function to return a formatted
 * string given a set of arguments in the array.
 *
 */
function Builder(specs, gui)
{
    var self = this;
    self.$cur = gui;
    self.$keyPath = []
    self.$value = {}
    self.$specs = specs
    self.$themeExclusions = {}
    self.$updatePaths = {}
    self.$converters = []

    self.mergeSpecs({
	'99/theme': setsubfolder({
	    save: setaction(function() {
		var exp = {}
		$.extend(true, exp, self.getValue());
		_.each(self.$themeExclusions, function(valkey, key) {
		    var obj = _.get(exp, key);
		    if ( obj && typeof obj === 'object' ) {
			if ( typeof(valkey) === 'object' && valkey.constructor === Array ) {
			    valkey.forEach(function(vk) { delete obj[vk]; });
			} else delete obj[valkey];
		    } else if ( valkey ) {
			if ( typeof(valkey) === 'object' && valkey.constructor === Array ) {
			    valkey.forEach(function(vk) { delete exp[vk]; });
			} else delete exp[valkey];
		    }
		});
		window._saveFile('settings.json', ("data:text/json;charset=utf-8," +
						   encodeURIComponent(JSON.stringify(exp))));
	    }),
	    load: setaction(function() {
		window._readFile(function(res) {
		    var jsonObj = JSON.parse(res);
		    $.extend(true, self.getValue(), jsonObj);
		    syncDisplay(gui);
		});
	    }),
	})
    });
}

Builder.prototype = Object.create(Object.prototype);

function syncDisplay(gui)
{
    gui.__controllers.forEach(ctrl => ctrl.updateDisplay());
    _.each(gui.__folders, fgui => syncDisplay(fgui));
}

Builder.prototype.syncDisplay = function()
{
    syncDisplay(this.$cur);
}

/*
 * gui is the dat.GUI object, the root or from a addFolder().
 *
 * obj is the specs or the description of fields contained in this level.
 *
 * opt contains default value for the key.
 *
 * $updatePaths contains a hash of (path => controller) and is used in
 * updateDisplay(). updateDisplay() is invoked from outside dat (and
 * DatSpec) to notify dat (and DatSpec) that a property value has been
 * changed from outside dat, and is used to update dat GUI to reflect
 * this changed value.
 *
 * $converters is an array of converter specs which need to be invoked
 * during convert().
 *
 * $keyPath is a stack of strings used to maintain the current
 * property path from the root.
 */
function builder(gui, obj, opt, $updatePaths, $converters, $keyPath)
{
    $keyPath = $keyPath || []
    _.keys(obj).sort().forEach(function(key) {
	var spec = obj[key];
	if ( key.split('/').length > 1 ) key = key.split('/', 2)[1];
	var value = key in opt && opt[key] !== null && opt[key] !== undefined ? opt[key] : spec.value;
	var ctrl;
	// console.log('key = %O, spec = %O, value = %O, kp = %O', key, spec, value, $keyPath.slice());
	switch(spec.type) {
	case 'color':
	    opt[key] = value;
	    ctrl = gui.addColor(opt, key);
	    break;

	case 'subfolder':
	    if ( ! (key in opt) ) opt[key] = {}
	    ctrl = gui.addFolder(key);
	    $keyPath.push(key);
	    builder(ctrl, spec.value, opt[key], $updatePaths, $converters, $keyPath);
	    $keyPath.pop();
	    if ( spec.openFolder ) ctrl.open();
	    break;

	case 'folder':
	    ctrl = gui.addFolder(key);
	    $keyPath.push(key);
	    builder(ctrl, spec.value, opt, $updatePaths, $converters, $keyPath);
	    $keyPath.pop();
	    break;

	case 'select':
	    opt[key] = value;
	    ctrl = gui.add(opt, key, spec.options);
	    break;

	case 'scalar':
	    opt[key] = 'mapper' in spec ? spec.mapper(value) : value;
	    var x = gui.add(opt, key);
	    if ( 'min' in spec ) x = x.min(spec.min); // a doozy here:
						      // x must be
						      // assigned to
						      // the return
						      // value, cannot
						      // just throw it
						      // away.
	    if ( 'max' in spec ) x = x.max(spec.max);
	    if ( 'step' in spec ) x = x.step(spec.step);
	    ctrl = x;
	    if ( 'converter' in spec ) $converters.push({ convert: spec.converter, keyPath: $keyPath.slice() });
	    break;

	case 'function':
	    opt[key] = function() { spec.value.call(this, ctrl); };
	    ctrl = gui.add(opt, key);
	    break;

	case 'additem':
	    var kp = $keyPath.slice();/* copy this value since it is
				       * used in the below function
				       * for later invocation. */
	    (function() {
		var ikeys = _.keys(opt).filter(x => x.startsWith('item-'));
		ikeys.forEach(function(ikey) {
		    var nspec = {}
		    var id = argon.makeid(8);
		    spec.value.__id = id;
		    spec.value['~ delete'] = setaction(function(thisCtrl) {
			delete ctrl.object[_.keys(ctrl.object).find(x => ctrl.object[x].__id === id)];
			var itemGui = thisCtrl.__gui;
			itemGui.parent.removeFolder(itemGui);
		    })
		    nspec[ikey] = setsubfolder(spec.value)
		    builder(gui, nspec, opt, $updatePaths, $converters, kp);
		});
	    })();
	    opt[key] = function() {
		var gui = ctrl.__gui;
		var ikeys = _.keys(opt).filter(x => x.startsWith('item-'));
		var fname = 'item-' + ikeys.length;
		var nspec = {}
		var id = argon.makeid(8);
		spec.value.__id = id;
		spec.value['~ delete'] = setaction(function(thisCtrl) {
		    delete ctrl.object[_.keys(ctrl.object).find(x => ctrl.object[x].__id === id)];
		    var itemGui = thisCtrl.__gui;
		    itemGui.parent.removeFolder(itemGui);
		})
		nspec[fname] = setsubfolder(spec.value)
		nspec[fname].openFolder = true;
		builder(gui, nspec, opt, $updatePaths, $converters, kp);
	    }
	    ctrl = gui.add(opt, key);
	    (function() {
		var pgui = ctrl.__gui;
		var key = '~ deleteAll'
		opt[key] = function() {
		    var ikeys = _.keys(ctrl.object).filter(x => x.startsWith('item-'));
		    ikeys.forEach(x => pgui.removeFolder(pgui.__folders[x]))
		    ikeys.forEach(x => delete ctrl.object[x]);
		}
		pgui.add(opt, key);
	    })();
	    break;

	case 'converter':
	    $converters.push({ convert: spec.value, keyPath: $keyPath.slice() });
	    break;
	}
	if ( typeof(spec) === 'object' ) {
	    if ( 'onChange' in spec ) ctrl.onChange(spec.onChange);
	    if ( 'onFinishChange' in spec ) ctrl.onFinishChange(spec.onFinishChange);
	    if ( spec.needUpdate ) {
		var path = $keyPath.slice();
		path.push(key);
		$updatePaths[path.join('.')] = ctrl;
	    }
	} else opt[key] = spec;
    });
}

Builder.prototype.buildFrom = function(obj, opt)
{
    builder(this.$cur, obj, opt, this.$updatePaths, this.$converters, this.$keyPath);
}

Builder.prototype.getSpecs = function()
{
    return this.$specs;
}

Builder.prototype.mergeSpecs = function(newSpecs)
{
    $.extend(true, this.$specs, newSpecs);
}

function removeFrom(target, arg)
{
    _.keys(arg).forEach(function(key) {
	if ( key === 'type' ) return;
	else if ( key === 'value' ) {
	    if ( arg.value && typeof arg.value === 'string' ) {
		if ( target && typeof target === 'object' && target.constructor === Object ) {
		    if ( 'value' in target ) {
			if ( arg.value in target.value ) delete target.value[arg.value];
			else console.warn('%O: not found for removal in %O', arg.value, target.value);
		    } else {
			console.warn('improper spec structure - "value" not found in %O', target);
		    }
		} else {
		    console.warn('improper spec structure - %O not an object', target);
		}
	    } else removeFrom(target.value, arg.value);
	}
	else if ( key in target ) removeFrom(target[key], arg[key]);
    });
}

Builder.prototype.removeSpecs = function(arg)
{
    if ( typeof arg === 'string' ) delete this.$specs[arg];
    else if ( arg && typeof arg === 'object' && arg.constructor === Object ) removeFrom(this.$specs, arg);
}

Builder.prototype.mergeExclusions = function(exclusions)
{
    $.extend(true, this.$themeExclusions, exclusions);
}

Builder.prototype.setValue = function(value) { this.$value = value; }

Builder.prototype.getValue = function() { return this.$value; }

Builder.prototype.convert = function(options) { return options; }

Builder.prototype.updateDisplay = function(options, arg) {}

Builder.prototype.build = function()
{
    this.buildFrom(this.$specs, this.$value);
}

Builder.prototype.applyConverters = function(options)
{
    var self = this;

    self.$converters.sort(function(a, b) { return b.keyPath.length - a.keyPath.length; });
    self.$converters.forEach(function(spec) {
	if ( typeof(spec.convert) === 'function' ) spec.convert(options, spec.keyPath);
    });
    return options;
}

Builder.prototype.updatePaths = function(path, value)
{
    var ctrl = this.$opts.$updatePaths[path]
    if ( ctrl ) ctrl.setValue(value);
}

function replUnicode()
{
    var self = this;
    this.regex = new RegExp("\\\\u\{([0-9a-fA-F]{1,})\}", "gi");
    this.converter = function(from, to) {
	return function(options) {
	    _.set(options, to, _.get(options, from, '').replace(self.regex, function(match, p1, offset) {
		return String.fromCharCode(parseInt(p1, 16));
	    }));
	}
    };
}

exports.DatSpec = {
    Builder: Builder,
    setbool: function(value) { return { type: 'scalar', value: value } },
    setstr: function(value, converter) {
	var x = { type: 'scalar', value: value || '' };
	if ( converter ) x.converter = converter;
	return x;
    },
    setopts: function(options, value) { return { type: 'select', options: options, value: value } },
    setcolor: function(value) { return { type: 'color', value: value || 'rgb(0, 0, 0)' } },
    setsubfolder: function(values) { return { type: 'subfolder', value: values } },
    setfolder: function(values) { return { type: 'folder', value: values } },
    setnum: function(value, min, max, step, mapper) {
	var x = { type: 'scalar', value: value };
	if ( min !== undefined ) x.min = min;
	if ( max !== undefined ) x.max = max;
	if ( step !== undefined ) x.step = step;
	if ( mapper !== undefined ) x.mapper = mapper;
	return x;
    },
    setaction: function(cbFn) { return { type: 'function', value: cbFn } },
    addItem: function(subspecs) { return { type: 'additem', value: subspecs } },
    converter: function(spec) { return { type: 'converter', value: spec } },
    addOnChange: function(spec, onChange) { spec.onChange = onChange; return spec; },
    addOnFinishChange: function(spec, onFinishChange) { spec.onFinishChange = onFinishChange; return spec; },
    addLiveUpdate: function(spec) { spec.needUpdate = true; return spec; },
    builder: builder,
    replUnicode: new replUnicode().converter,
}

/*
 * Recursively finds "key" starting with object. Returns array of
 * dot-separated paths where key is found (suitable for
 * _.get()). Descends only objects (skips arrays).
 *
 */
exports.DatSpec.findKeyRec = function(obj, key, arr, path)
{
    arr = arr || []
    path = path || ''
    _.keys(obj).filter(x=>key===x).forEach(x=>arr.push(path+(path.length==0?'':'.')+x));
    _.each(obj,function(val,x) {
	if ( val && typeof val === 'object' && val.constructor !== Array )
	    exports.DatSpec.findKeyRec(val, key, arr, path + (path.length == 0 ? '' : '.') + x);
    });
    return arr;
}

var setsubfolder = exports.DatSpec.setsubfolder;
var setfolder = exports.DatSpec.setfolder;
var setaction = exports.DatSpec.setaction;
